module.exports = __webpack_public_path__ + "img/TAC.b9cf441a.png";